// Semantic status colors
export const GREEN = '#22c55e';   // green-500 (success)
export const RED = '#ef4444';     // red-500 (error/failure)
export const AMBER = '#F59E0B';   // amber-500 (warning)
export const YELLOW = '#FBBF24';  // amber-300 (caution)

// Primary palette
export const BLUE = '#3B82F6';    // blue-500
export const BLUE_LIGHT = '#60A5FA'; // blue-400
export const BLUE_DARK = '#2563EB';  // blue-600
export const CYAN = '#7DD3FC';    // sky-300
export const CYAN_DARK = '#0EA5E9'; // sky-500
export const SKY = '#38BDF8';     // sky-400
export const SKY_DARK = '#0284C7'; // sky-600

// Accent
export const PURPLE = '#8B5CF6';  // violet-500
export const PURPLE_DARK = '#7C3AED'; // violet-600

// Neutral
export const GRAY = '#6B7280';    // gray-500
export const GRAY_DARK = '#4B5563'; // gray-700

// Prebuilt palettes
export const BLUE_SHADES: string[] = [BLUE, BLUE_LIGHT, BLUE_DARK, '#93C5FD', '#1D4ED8', '#BFDBFE', '#1E40AF', '#DBEAFE', '#1E3A8A', BLUE];
export const STATUS_COLORS: string[] = [GREEN, RED, AMBER, BLUE]; // success, error, warning, info
export const SEVERITY_COLORS: string[] = [RED, AMBER, YELLOW, GREEN]; // critical → low
